import { userService } from './../../../Services/userService';
import { RenewBindMdl } from './../../../Models/RenewBindMdl';
import { MotorproposalTrackingService } from './../../../Services/MotorproposalTrackingService';
import { renewalProposalService } from './../../../Services/renewalProposalService';
import { Subscription } from 'rxjs';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Router } from '@angular/router';
import { Component } from '@angular/core';
import { TPLProposal } from '../../../Models/TPLProposal';
import { BindMdl } from '../../../Models/BindMdl';
import { restURL } from '../../../Models/restURL';
import { tplCoversPipe } from '../../../Pipes/tplCoversPipe';
import { tplManCovers } from '../../../Pipes/tplManCovers';
import { LanguageService } from '../../../Services/languageService';
import Swal from 'sweetalert2';
import { mdlPayloadRequest } from '../../../Models/mdlPayloadRequest';
import { mdlPayloadResponse } from '../../../Models/mdlPayloadResponse';
import { motorProposalService } from '../../../Services/motorProposalService';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'RenewalPremiumInfo',
  templateUrl: './RenewalPremiumInfo.html',
  styleUrls: ['./RenewalPremiumInfo.css']
})
export class RenewalPremiumInfo {

  public prObj: TPLProposal = new TPLProposal();
  public bindObj: RenewBindMdl = new RenewBindMdl();
  //public httpOptions = { headers: new HttpHeaders({ 'Content-Type': 'application/json' }) };
  public isShowLoading: boolean;
  public LngSubscription: Subscription;
  public Lng: string;
  public objPayloadRequest: mdlPayloadRequest = new mdlPayloadRequest();
  public objPayloadResponse: mdlPayloadResponse = new mdlPayloadResponse();

  constructor(private translate:TranslateService,private EncriptService: motorProposalService, private router: Router, private http: HttpClient, private url: restURL, private proposalService: renewalProposalService, private lngService: LanguageService, private trackingObj: MotorproposalTrackingService, private userinfo: userService) {
    this.LngSubscription = this.lngService.grtLng().subscribe(lng => { this.Lng = lng });

    if (sessionStorage.getItem("Language") != null) {
      this.Lng = sessionStorage.getItem("Language");
    }
    else {
      this.Lng = "en";
    }
    this.prObj = this.proposalService.getRenewalProposalObj();
    this.isShowLoading = false;
    this.bindObj = this.proposalService.getRenewalBindObj();
    this.getPremium();
  }
  goPrev() {
    if (this.prObj.st.StatusCode == "F") {
      this.prObj.st.StatusCode = "";
    }
    this.proposalService.saveRenewalProposalObj(this.prObj);
    this.proposalService.saveRenewalBindObj(this.bindObj);
    if (this.prObj.isDriverRequired == true) {
      sessionStorage.setItem("CurrentRoute", "RenewalDriverInfo");
      this.router.navigate(['NewDashboard/RenewalProposal/RenewalDriverInfo']);
    }
    else {
      sessionStorage.setItem("CurrentRoute", "RenewalInsuredInfo");
      this.router.navigate(['NewDashboard/RenewalProposal/RenewalBasicInfo']);
    }
  }

  goNext() {
    this.proposalService.saveRenewalProposalObj(this.prObj);
    this.proposalService.saveRenewalBindObj(this.bindObj);
    sessionStorage.setItem("CurrentRoute", "RenewalVehicleDetails");
    if (this.prObj.st.StatusCode == "S") {
      this.router.navigate(['NewDashboard/RenewalProposal/RenewalVehicleDetails']);
    }
  }

  updatePremium() {

    let TotalPremium: Number = 0;
    let GrossPremium: number = 0;
    let TotalPremiumBeforeVAT: number = 0;
    let VATAmount: number = 0;
    GrossPremium = Number(this.prObj.BasicPremium) + Number(this.prObj.Adminfee) + Number(this.prObj.AgeLoading) + Number(this.prObj.DriverCase) + Number(this.prObj.VehicleCase);

    if (this.prObj.AddDriverChk) {
      if (Number(this.prObj.AddDriverAmt) > 0) {
        GrossPremium = GrossPremium + Number(this.prObj.AddDriverAmt);
      }

    }
    if (this.prObj.AddPassChk) {
      if (Number(this.prObj.AddPassAmt) > 0) {
        GrossPremium = GrossPremium + Number(this.prObj.AddPassAmt);
      }
    }
    this.prObj.GrossPremium = GrossPremium.toString();

    if (Number(this.prObj.NCDDiscountAmt) > 0) {
      GrossPremium = GrossPremium - Number(this.prObj.NCDDiscountAmt)
    }

    if (Number(this.prObj.LDAmount) > 0) {
      GrossPremium = GrossPremium - Number(this.prObj.LDAmount);
    }

    if (Number(this.prObj.PromoDiscount) > 0) {
      GrossPremium = GrossPremium - Number(this.prObj.PromoDiscount);
    }
    if (Number(this.prObj.CrossSellDiscountAmt) > 0) {
      GrossPremium = GrossPremium - Number(this.prObj.CrossSellDiscountAmt);
    }

    if (Number(this.prObj.DriverDiscountAmt) > 0) {
      GrossPremium = GrossPremium - Number(this.prObj.DriverDiscountAmt);
    }
    // GrossPremium = GrossPremium - Number(this.prObj.NCDDiscountAmt) - Number(this.prObj.LDAmount) - Number(this.prObj.PromoDiscount) - Number(this.prObj.CrossSellDiscountAmt);
    TotalPremiumBeforeVAT = GrossPremium;

    this.prObj.TotPremiumBVAT = TotalPremiumBeforeVAT.toString();
    VATAmount = (TotalPremiumBeforeVAT * Number(this.prObj.VATPercent)) / 100;

    this.prObj.VATAmount = VATAmount.toString();

    TotalPremium = TotalPremiumBeforeVAT + VATAmount;
    if (Number(this.prObj.UPR_VAT_AMOUNT) > 0) {
      TotalPremium = Number(TotalPremium) + Number(this.prObj.UPR_VAT_AMOUNT);
    }

    this.prObj.TotalPremium = TotalPremium.toString();

  }


  getPremium() {

    this.objPayloadRequest.Payload = this.EncriptService.EncriptPayload(JSON.stringify(this.prObj));

    this.isShowLoading = true;
    //this.http.post<TPLProposal>(this.url.baseURL + "/RenewPolicy/getRenewPremium", this.prObj, this.userinfo.getHttpOptions()).toPromise()
    this.http.post<mdlPayloadResponse>(this.url.baseURL + "/RenewPolicy/getRenewPremium", this.objPayloadRequest, this.userinfo.getHttpOptions()).toPromise()
      .then((res) => {
        //this.prObj = res;

        //New Line Start
        this.objPayloadResponse = res;
        this.prObj = JSON.parse(JSON.stringify(this.EncriptService.DecriptPayload(this.objPayloadResponse.PayloadResponse)));
        //NewLine End


        this.proposalService.saveRenewalProposalObj(this.prObj);
        this.isShowLoading = false;
        if (this.prObj.st.StatusCode == "F") {
          this.Lng == "ar" ? swal(this.prObj.st.StatusDescAr) : swal(this.prObj.st.StatusDesc);
          this.router.navigate(['/NewDashboard/Policy']);
        }

      }, (error) => {
        this.isShowLoading = false;
        this.userinfo.checkTokenStatus(error);

      });
  }

  addOtherCovers() {






  }
  addDABCover(val) {
    if (val == false) {
      if (this.prObj.AddPassChk == true && this.prObj.AddDriverChk == false) {
        this.prObj.AddPassChk = false;
      }
    }
    this.updatePremium();
  }
  addPABCover(val) {
    if (val) {
      if (this.prObj.AddPassChk == true && this.prObj.AddDriverChk == false) {
        this.prObj.AddDriverChk = true;
      }
    }
    this.updatePremium();
  }

  ApplyRenewalPromo() {
    this.isShowLoading = true;

    this.objPayloadRequest.Payload = this.EncriptService.EncriptPayload(JSON.stringify(this.prObj));

    //this.http.post<TPLProposal>(this.url.baseURL + "/RenewPolicy/ApplyRenewalPromo", this.prObj, this.userinfo.getHttpOptions()).toPromise().then((res) => {
      this.http.post<mdlPayloadResponse>(this.url.baseURL + "/RenewPolicy/ApplyRenewalPromo", this.objPayloadRequest, this.userinfo.getHttpOptions()).toPromise().then((res) => {
      //this.prObj = res;

       //New Line Start
       this.objPayloadResponse = res;
       this.prObj = JSON.parse(JSON.stringify(this.EncriptService.DecriptPayload(this.objPayloadResponse.PayloadResponse)));
       //NewLine End


      //this.Lng == "ar" ? Swal(this.prObj.PromoRes.st.StatusDescAr) : Swal(this.prObj.PromoRes.st.StatusDesc);
      Swal(this.translate.instant(this.prObj.PromoRes.st.StatusDesc))

      this.proposalService.saveRenewalProposalObj(this.prObj);
      this.isShowLoading = false;

    }, (res) => {
      this.isShowLoading = false;
      this.userinfo.checkTokenStatus(res);
    });


  }

}


// WEBPACK FOOTER //
// D:/GGI/LIMRA_GGI/PROMOSND95/GGI_ONLINE_ANGULAR__2022_10_17_ClaimTracking/src/Pages/MotorPortal/RenewalPremiumInfo/RenewalPremiumInfo.ts